
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ToolbarSeparator } from '../../core';
import { getToolsMode } from '../../map';

import ButtonCommandMscTool from './ButtonCommandMscTool';

const ButtonCommandMscTools = (props) => {

    const TOOLS = [{
        group: 'none',
        toolId: 'SelectObjectControl',
        iconName: 'Info',
        title: 'Výchozí'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasurePoint',
        iconName: 'MeasurePoint',
        title: 'Měření bodu'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureLine',
        iconName: 'MeasureLine',
        title: 'Měření délky'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureTriangle',
        iconName: 'MeasureTriangle',
        title: 'Měření trojúhelníku'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasurePerpendicular',
        iconName: 'MeasurePerpendicular',
        title: 'Měření na kolmici'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureLineHorizontal',
        iconName: 'MeasureLineHorizontal',
        title: 'Měření horizontální délky'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureLineVertical',
        iconName: 'MeasureLineVertical',
        title: 'Měření vertikální délky'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureDmtHeight',
        iconName: 'MeasureDmtHeight',
        title: 'Měření výšky nad DMT'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasurePointAngle',
        iconName: 'MeasurePointAngle',
        title: 'Měření výšky bodem a úhlem'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureRectVertical',
        iconName: 'MeasureRectVertical',
        title: 'Měření svislého obdélníku'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureRect',
        iconName: 'MeasureRect',
        title: 'Měření obdélníku'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasurePolygon',
        iconName: 'MeasurePolygon',
        title: 'Měření polygonu'
    }, {
        group: 'measure',
        toolId: 'PointCloudMeasureEdit',
        iconName: 'MeasureEdit',
        title: 'Editace měření'
    }, {
        group: 'clip',
        toolId: 'PointCloudClipBoxControl',
        iconName: 'ClipBox',
        title: 'Ořezání mračna bodů boxem'
    }];

    const [selectedToolId, setSelectedToolId] = useState(TOOLS[0].toolId);

    const toolsMode = useSelector(state => getToolsMode(state.map.map));

    // ToDo: check selected tool when tools are changed

    const getToolById = (toolId) => {
        return TOOLS.reduce((previous, current) => {
            return (current.toolId === toolId)
                ? current
                : previous;
        }, null);
    }

    const handleClick = (toolId) => {
        setSelectedToolId(toolId);
        if (props.onSelectTool) {
            props.onSelectTool(toolId, getToolById(toolId));
        }
    }
    const renderButtonTools = (items, group) => {
        let components = items.filter(item => {
            return (item.group === group)
        }).map(item => {
            return <ButtonCommandMscTool
                key={item.toolId}
                toolId={item.toolId}
                iconName={item.iconName}
                title={item.title}
                selected={selectedToolId === item.toolId}
                onClick={handleClick}
            />
        });
        if (props.additionalButtonTools && props.additionalButtonTools[group]) {
            components = [
                ...components,
                ...props.additionalButtonTools[group]
            ];
        }
        return components;
    }

    const tools = props.tools || TOOLS.map(item => item.toolId);

    const filteredTools = TOOLS.filter(item => {
        return (tools.indexOf(item.toolId) !== -1);
    });

    let buttons = [
        ...renderButtonTools(filteredTools, 'none'),
        <ToolbarSeparator key="separator1"/>,
        ...renderButtonTools(filteredTools, 'clip'),
    ];

    // ToDo: use constant for toolsMode from module `map`
    if (toolsMode === 'MEASURE') {
        buttons = [
            ...buttons,
            <ToolbarSeparator key="separator2" />,
            ...renderButtonTools(filteredTools, 'measure')
        ]
    }

    return buttons;
}

export default ButtonCommandMscTools;
